import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UploaderMessages } from '../../models/component-messages/uploader-messages';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss']
})
export class UploaderComponent implements OnInit {
  @Input() title: string;
  @Input() size: number;
  @Output() errorSizeEvent = new EventEmitter<string>();
  @Output() errorLengthEvent = new EventEmitter<string>();
  @Output() uploadEvent = new EventEmitter<File>();
  @ViewChild('attachments', {static: false}) attachment: any; // Après suppression d'un fichier, permet de l'uploader à nouveau.

  public files: any = [];
  public errorFileLength: string;
  public errorFileSize: string;
  public fileNameNoTruncated: string;
  public uploaderMessages = new UploaderMessages();

  constructor(private commonService:CommonService) {
  }

  ngOnInit() {
  }

  public uploadFile(event) {
    const eventObj = event as MSInputMethodContext;
    const target = eventObj.target as HTMLInputElement;
    this.errorFileLength = '';
    this.errorFileSize = '';

    if (target.files.length) { // Vérifie que l'event à bien récupérer un fichier sinon provoque une erreur.
      const file: File = target.files[0];
      if ((file.size / 1048576) < 20) {
        this.fileNameNoTruncated = file.name;
        const fileName = this.commonService.truncateFileName(file.name);
        if (this.size === 0) {
          this.files.push(fileName);
        } else {
          if (this.files.length === this.size) {
            this.errorFileLength = '';
            this.files.splice(0, 1, fileName);
            document.getElementById('file-name').innerHTML = file.name;
          } else {
            this.files.push(fileName);
          }
        }
        this.uploadEvent.emit(file);
      } else {
        this.errorFileSize = 'error';
      }
    }
    this.attachment.nativeElement.value = '';
    this.errorLengthEvent.emit(this.errorFileLength);
    this.errorSizeEvent.emit(this.errorFileSize);
  }

  public uploadFileDropped(event) {
    this.errorFileLength = '';
    this.errorFileSize = '';

    if (this.size === 0) {
      for (const file of event) {
        if ((file.size / 1048576) < 20) {
          this.fileNameNoTruncated = file.name;
          const fileName = this.commonService.truncateFileName(file.name);
          this.files.push(fileName);
          this.uploadEvent.emit(file);
        } else {
          this.errorFileSize = 'error';
        }
      }
      this.errorSizeEvent.emit(this.errorFileSize);
      this.errorLengthEvent.emit(this.errorFileLength);
    } else {
      if (event.length > this.size) {
        this.errorFileLength = 'error';
      } else {
        for (const file of event) {
          if ((file.size / 1048576) < 20) {
            this.fileNameNoTruncated = file.name;
            const fileName = this.commonService.truncateFileName(file.name);
            if (this.files.length >= this.size) {
              this.files.splice(0, 1, fileName);
              document.getElementById('file-name').innerHTML = fileName;
            } else {
              this.files.push(fileName);
            }
            this.uploadEvent.emit(file);
          } else {
            this.errorFileSize = 'error';
          }
        }
      }
      this.errorSizeEvent.emit(this.errorFileSize);
      this.errorLengthEvent.emit(this.errorFileLength);
    }
  }

  public deleteAttachment(index) {
    this.errorFileLength = '';
    this.errorFileSize = '';
    this.files.splice(index, 1);
    this.errorSizeEvent.emit(this.errorFileSize);
    this.errorLengthEvent.emit(this.errorFileLength);
  }

  public isEnterPressed(event) {
    const input = event.target;
    input.addEventListener('keyup', (keyEvent) => {
      if (keyEvent.key === "Enter") {
        // Cancel the default action, if needed
        keyEvent.preventDefault();
        // Trigger the button element with a click
        document.getElementById('input-file').click();
      }
    });
  }


}
